import pro1 from "../assets/delivery.jpeg"
import pro2 from "../assets/music2.jpg"
import pro3 from "../assets/ecommerce.jpg"
const ProjectCardData = [

    {
        imagsrc: pro1,
        title: "Food Website Design",
        text:"Thriving food app and top ranked food app.Wow! Really a good app for food search",
        view:""
    },
    {
        imagsrc: pro2,
        title: "Music Listening app",
        text:"A good music Listening app which can give instant relaxtion Thousands Of music in one app which helps to keep the person love in music",
        view:""
    },
    {
        imagsrc: pro3,
        title: "Ecommerce Website Design",
        text:"Thriving Facebook community and top-ranked podcast, Any inspires a grounded, tangible and self-affirming sense of Wow!really can do this for over 100,000 online enterprenurs ",
        view:""
    },
];

export default ProjectCardData;